import React from 'react';
import { metricsList } from '../../components/metricsList';
import { useWidget } from 'components/Widget/useWidget';
import MetricSelector from 'components/Selects/MetricSelector';

const WidgetTitle = ({}) => {
  const { setChartConfig, chartConfig } = useWidget();

  const handleMenuClick = ({ key }) => {
    setChartConfig((prevConfig) => ({
      ...prevConfig,
      selected_metrics: key,
    }));
  };

  return (
    <MetricSelector
      onChage={handleMenuClick}
      metricsList={metricsList}
      selected_metrics={chartConfig?.selected_metrics}
    />
  );
};

export default WidgetTitle;
